import type { QueryClient } from '@tanstack/react-query';

export const SUPERVISOR_PRECISION_QUERY_KEY = ['getSupervisorPrecision'] as const;

/**
 * Refresh everything a finding action or a finalize can change: the project's findings list
 * (rows, statuses, `pendingFinalizeCount`), the precision chips, and any open entity view
 * (badges and the corrected projection; the prefix also covers an entity peeked from the project),
 * and any open page view (its finding badges and statuses).
 * `allProjects` refreshes every project's findings list instead: a revert from the entity view
 * changes a shared entity whose findings another project's list may show.
 */
export const invalidateSupervisorQueries = async (
  queryClient: QueryClient,
  projectId: string,
  { allProjects = false }: { allProjects?: boolean } = {},
): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: allProjects ? ['getProjectSupervisorFindings'] : ['getProjectSupervisorFindings', projectId],
    }),
    queryClient.invalidateQueries({ queryKey: SUPERVISOR_PRECISION_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: ['reconstructed-document'] }),
    queryClient.invalidateQueries({ queryKey: ['documentPage'] }),
  ]);
};
